import styled from 'styled-components';
import { Modal as SemanticModal } from 'semantic-ui-react';
import { CenteredLoader } from '@playbookux/playbook-web-core';

export const Content = styled.div`
  display: block;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
`;

export const Loader = styled(CenteredLoader)``;

export const Modal = styled(SemanticModal)`
  &&&{
    width: 300px;
  }
`;
